/*
 * @Author: Chao Yang
 * @Date: 2020-09-07 17:13:27
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-07 17:13:36
 */
import { InjectionToken } from '@angular/core';

export const CONFIG_DATA = new InjectionToken<{}>('CONFIG_DATA');
